import React, {useEffect, useState, useRef, useCallback} from 'react';
import PropTypes from 'prop-types';
import {scaleLinear, scaleTime, extent, select} from 'd3';
import {isActive, formatYear} from '../../../lib/helpers';

const Population = ({data, width, height, activeYear, lang}) => {
  const [bars, setBars] = useState([]);
  const barsRef = useRef();
  const barWidth = Math.ceil(width * 0.0075);
  const draw = useCallback(() => {
    const xExtent = extent(data, ({year}) => formatYear(year));
    const xScale =
      lang === 'en'
        ? scaleTime().domain(xExtent).range([0, width])
        : scaleTime()
            .domain(xExtent)
            .range([width, 0 + 20]);
    const yExtent = extent(data, (d) => d.population);
    const yScale = scaleLinear().domain(yExtent).range([height, 0]);

    const newBars = data.map((d) => {
      return {
        x: xScale(formatYear(d.year)),
        y: yScale(d.population),
        height: height - yScale(d.population),
        year: d.year,
      };
    });
    setBars(newBars);
  }, [data, height, width, lang]);

  const animate = useCallback(() => {
    let delayCount = 0;
    select(barsRef.current)
      .selectAll('rect')
      .data(bars)
      .attr('fill-opacity', '0.5')
      .attr('y', (d) => (isActive(d.year, activeYear) ? height : d.y))
      .transition()
      .attr('fill-opacity', (d) => (isActive(d.year, activeYear) ? '1' : '0.5'))
      .attr('y', (d) => d.y)
      .attr('height', (d) => d.height)
      .delay((d) => {
        delayCount = isActive(d.year, activeYear)
          ? (delayCount += 1)
          : delayCount;
        return delayCount * 100;
      });
    delayCount = 0;
  }, [activeYear, bars, height]);

  useEffect(() => {
    draw();
  }, [data, draw]);

  useEffect(() => {
    animate();
  }, [bars, animate]);

  return data.length > 0 ? (
    <svg>
      <g ref={barsRef}>
        {bars.map((d) => (
          <rect key={d.year} x={d.x} width={barWidth} fill='#FFF' />
        ))}
      </g>
    </svg>
  ) : null;
};

Population.propTypes = {
  data: PropTypes.array,
  activeYear: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  lang: PropTypes.string,
};

export default Population;
